import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Tooltip } from 'base-ui'

export const ProductOutOfStockReminderButtonTooltipLoginRequired: FC = () => {
  return (
    <Tooltip
      arrow
      clickTrigger
      placement="top"
      title={<FormattedMessage id="general.loginRequired" />}
    >
      <Button className="mb-2.5 w-full whitespace-normal">
        <FormattedMessage id="backInStock.button.activate" />
      </Button>
    </Tooltip>
  )
}
